export const CLASS_SIGNUP_BANNER = {
  preLogin: {
    title: 'Join to access 3,00,000+ free classes',
    desc: 'Create a free account and access free classes, playlists & more',
    img: 'class.svg'
  },
  postLogin: {
    title: '3,000,000+ free classes available',
    desc: 'Start learning from topic wise free classes, curated playlists & more',
    buttonCta: 'Explore classes',
    url: (goalUID) => `/goal/-/${goalUID}`
  }
};

export const TEST_SIGNUP_BANNER = {
  preLogin: {
    title: 'Join to access 10,000+ free tests',
    desc: 'Create a free account and access tests, practice questions & more',
    img: 'test.svg'
  },
  postLogin: {
    title: '10,000+ free tests available',
    desc: 'Start learning from tests, practice questions & more',
    buttonCta: 'Explore tests',
    url: (goalUID) => `/goal/-/${goalUID}/test-series`
  }
};

export const EDUCATOR_SIGNUP_BANNER = {
  preLogin: {
    title: 'Join to learn from 2,000+ top educators',
    desc: 'Create a free account and access courses, free classes & more',
    img: 'educator.svg'
  },
  postLogin: {
    title: 'Learn from 2,000+ educators',
    desc: 'Start learning from free classes of top educators',
    buttonCta: 'Explore',
    url: (goalUID) => `/goal/-/${goalUID}`
  }
};

export const COURSE_SIGNUP_BANNER = {
  preLogin: {
    title: 'Join to access 50,000+ free courses',
    desc: 'Create a free account and access courses, free classes & more',
    img: 'course.svg'
  },
  postLogin: {
    title: '10,000+ free courses available',
    desc: 'Start learning from courses, free classes & more',
    buttonCta: 'Explore courses',
    url: (goalUID) => `/goal/-/${goalUID}/free-platform`
  }
};
